/**
 * Asset detail header: who holds it, where it sits, since when.
 *
 * Person and project are independent. A named holder on a site (desktop on
 * P2210-011) must show both. Project-only rows (deployed monitors) have no
 * holder. Employee self-view omits their own name.
 */

export function getAssetHeaderMetaVisibility({
  deployedProjectName,
  currentAssigneeName,
  isSelfAssignee = false,
  sinceDate,
} = {}) {
  const showHeaderProject = Boolean(deployedProjectName);
  const showHeaderHolder = Boolean(currentAssigneeName && !isSelfAssignee);
  const showHeaderSince = Boolean(sinceDate);
  return {
    showHeaderProject,
    showHeaderHolder,
    showHeaderSince,
    showHeaderMetaRow: showHeaderProject || showHeaderHolder || showHeaderSince,
  };
}
